import { axios } from '~/clients';
import { DELIVERY_CONTEXT } from '~/constants/endpoints';
import { DeliveryContext } from '~/contracts/vdp';

const fetchDeliveryContext = (
  { zip }: { zip: string },
  controller: AbortController
) =>
  axios.get<DeliveryContext>(`${DELIVERY_CONTEXT}?zip5=${zip}`, {
    signal: controller.signal
  });

export default fetchDeliveryContext;
